<template>
  <h1 class="mb-5 flex items-center gap-2 text-2xl font-medium">
    <NuxtLink
      v-if="props.defaultBackTo"
      :to="backTo"
      class="flex h-8 w-8 items-center justify-center rounded-full bg-blue-700 text-white"
    >
      <Icon name="tabler:arrow-left" />
    </NuxtLink>
    <slot />
  </h1>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from "vue-router"

const props = defineProps<{
  defaultBackTo?: RouteLocationRaw
}>()

const router = useRouter()
const backTo = computed(() => (router.options.history.state.back || props.defaultBackTo) as RouteLocationRaw)
</script>
